/**
 * ERC Different Unit Footprint Validator Adapter for DRC System
 *
 * This validator checks for multi-unit components where units have different footprints.
 *
 * Note: This validator requires footprint data which is not currently available
 * in IPartVersionData. Returns empty results until footprint data is added.
 *
 * Feature-gated via DrcEnabledCheckers.ErcDifferentUnitFootprintValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
/**
 * Validator that checks for different footprints in multi-unit components.
 */
export class ErcDifferentUnitFootprintValidator {
    reviewType = ReviewType.DesignRuleCheckErcDifferentUnitFootprint;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(_inputs) {
        const foundProblems = [];
        // Note: This validator requires footprint data which is not currently
        // available in IPartVersionData. Returns empty results until footprint data is added.
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcDifferentUnitFootprintValidator.js.map